module.exports = __webpack_public_path__ + "static/media/Mockup_bettilt--desktop.344c92d2.png";